<template>
  <div
    class="authList"
    :style="{
      justifyContent: showList.length > 4 ? 'flex-start' : 'center',
    }"
  >
    <el-image
      v-for="item in authorizedList"
      :key="item.id"
      class="authImg"
      :src="item.fileUrl"
      :preview-src-list="showList"
    />
  </div>
</template>

<script>
export default {
  props: {
    authorizedList: {
      tpye: Array,
      default: () => [],
    },
  },
  computed: {
    showList() {
      return (this.authorizedList || []).map((i) => {
        return i.fileUrl;
      });
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.authList {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: auto;
  padding-bottom: 20px;
  .authImg {
    margin: 0 24px;
    border-radius: 8px;
    border: 8px solid rgba(0, 0, 0, 0.1);
    height: 316px;
    flex-shrink: 0;
  }
}
</style>
